import { render, staticRenderFns } from "./FormPlans.vue?vue&type=template&id=ccaf0ac6&"
import script from "./FormPlans.vue?vue&type=script&lang=js&"
export * from "./FormPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports